import { XMLParser, XMLBuilder, } from 'fast-xml-parser';
export function toXml(content, options) {
    const builder = new XMLBuilder(options);
    return builder.build(content);
}
export function xmlToJson(xml, options) {
    const parser = new XMLParser(options);
    return parser.parse(xml);
}
